import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { SpAuthMfaService, SpAuthService } from '@core/services';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SpAuthGuard implements CanActivate {
  constructor(private authService: SpAuthService, private authMfaSvc: SpAuthMfaService) {}

  canActivate(): Observable<boolean> {
    console.log('canActivate started...');
    let isAuthenticated = false;
    this.authService.isAuthenticated$.pipe(take(1)).subscribe(isAuth => {
      if (isAuth) {
        isAuthenticated = isAuth;
      }
    });
    if (isAuthenticated) {
      this.authService.RetrieveMfaAccessToken();
    }

    return this.authMfaSvc.mfaAccessTokenSilently$.pipe(
      switchMap(mfaToken => {
        console.log('canActivate return mfaAccessTokenSilently emitted...');
        return of(mfaToken?.length > 0);
      })
    );
  }
}
